import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminForgotPassword() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            const res = await fetch(`${API}/api/auth/forgot-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });
            if (!res.ok) {
                const body = await res.json().catch(() => ({}));
                throw new Error(typeof body.detail === "string" ? body.detail : "Could not process the request.");
            }
            setSent(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#0B1120] px-6 font-adminSans text-white">
            <div className="w-full max-w-md rounded-lg border border-white/10 bg-white p-8 text-[#0F172A] shadow-2xl" data-testid="admin-forgot-password-page">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-[#0B1120] font-adminDisplay text-xs font-bold tracking-[0.12em] text-[#D4AF37]">AGL</span>
                <h1 className="mt-6 font-adminDisplay text-3xl font-bold tracking-tight">Reset Password</h1>
                <p className="mt-2 text-sm leading-relaxed text-[#64748B]">Enter your administrator email. If the account exists, a secure reset link will be sent.</p>
                {sent ? (
                    <div data-testid="admin-forgot-success" className="mt-6 rounded-md border border-emerald-200 bg-emerald-50 px-4 py-4 text-sm text-emerald-700">
                        If an admin account exists for that email, a reset link has been sent. The link expires in 30 minutes.
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-6 space-y-5" data-testid="admin-forgot-form">
                        <div>
                            <label htmlFor="reset-email" className="mb-2 block text-xs font-bold uppercase tracking-[0.16em] text-[#64748B]">Email address</label>
                            <input id="reset-email" data-testid="admin-reset-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-md border border-[#E2E8F0] px-4 py-3 text-sm outline-none focus:border-[#D4AF37] focus:ring-2 focus:ring-[#D4AF37]/30" />
                        </div>
                        {error && <p data-testid="admin-forgot-error" className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>}
                        <button type="submit" data-testid="admin-forgot-submit" disabled={busy} className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-[#0B1120] px-5 py-3.5 text-xs font-bold uppercase tracking-[0.16em] text-white transition-colors hover:bg-[#1E293B] disabled:opacity-60">
                            {busy ? <Loader2 size={15} className="animate-spin" /> : <Mail size={15} />}
                            Send Reset Link
                        </button>
                    </form>
                )}
                <Link to="/admin/login" data-testid="forgot-back-login" className="mt-6 inline-block text-xs font-bold uppercase tracking-[0.16em] text-[#64748B] hover:text-[#D4AF37]">← Back to sign in</Link>
            </div>
        </div>
    );
}
